/* VENDORED — DO NOT EDIT BY HAND. See scripts/vendor-manifest.mjs.
   source:  andavo-dev libs/client/web/shared/ui/nomad/src/lib/Skeleton/Skeleton.tsx
   commit:  b875130356
   repoint: this file maps to @andavo/* at merge into andavo-dev.
 */
import { cn } from '../../../util/cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-surface-foreground',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
